const clerkMvp = {
  id: 'clerk-mvp',
  title: 'Clerk Preparation (MVP)',
  description: 'Seeded MVP path for Clerk exam — 3 subjects with topics and previous papers.',
  estimatedHours: 120,
  orderedSubjects: [
    {
      id: 'english',
      title: 'English Language',
      order: 1,
      topics: [
        { id: 'vocab', title: 'Vocabulary & Synonyms', order: 1, estimatedMinutes: 120, practiceCount: 40 },
        { id: 'grammar', title: 'Grammar & Usage', order: 2, estimatedMinutes: 150, practiceCount: 50 },
        { id: 'comprehension', title: 'Reading Comprehension', order: 3, estimatedMinutes: 180, practiceCount: 30 },
      ],
      previousPapers: [
        { paperId: 'clerk-2019', title: 'Clerk 2019 Paper', year: 2019 },
        { paperId: 'clerk-2020', title: 'Clerk 2020 Paper', year: 2020 },
      ],
    },
    {
      id: 'math',
      title: 'Quantitative Aptitude',
      order: 2,
      topics: [
        { id: 'arithmetic', title: 'Arithmetic', order: 1, estimatedMinutes: 200, practiceCount: 60 },
        { id: 'algebra', title: 'Algebra & Number Theory', order: 2, estimatedMinutes: 160, practiceCount: 40 },
      ],
      previousPapers: [
        { paperId: 'clerk-2018', title: 'Clerk 2018 Paper', year: 2018 },
      ],
    },
    {
      id: 'general',
      title: 'General Awareness',
      order: 3,
      topics: [
        { id: 'current-events', title: 'Current Affairs', order: 1, estimatedMinutes: 100, practiceCount: 30 },
        { id: 'static', title: 'Static GK', order: 2, estimatedMinutes: 120, practiceCount: 25 },
      ],
      previousPapers: [],
    },
  ],
};

const studyPaths = [clerkMvp];
export default studyPaths;
